<script setup>
import { useGlobalStore } from '@stores/global'

import Button from '@components/global/button.vue'

const global = useGlobalStore()
</script>
<template>
	<div class="relative overflow-hidden">
		<section class="container flex justify-center">
			<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/about-1.svg" class="absolute -top-[15%] right-[40%] h-full w-full" alt="lines" />
			<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/lines/about-2.svg" class="absolute -top-[15%] left-[40%] h-full w-full" alt="lines" />
			<div class="relative flex flex-col items-center gap-4 text-center lg:w-[40%]">
				<span class="h9">About us</span>
				<h1>What the f*ck is a Gardener?</h1>
				<span class="text mt-4">A Gardener is more than just a fan of cannabis—they're part of a community that thrives on connection, culture, and shared experiences. Born from social media, Gardeners have embraced a new way to talk, learn, and grow together without boundaries. Whether you're here to explore, educate, or simply enjoy the vibe, being a Gardener means you’re never growing alone.</span>
			</div>
		</section>
	</div>
</template>
